import * as ActionTypes from "./ActionTypes";

export const changeLanguage = (language) => ({
  type: ActionTypes.Change_Language,
  payload: language,
});
